import React, { useState, useEffect } from 'react';

import ReactLoading from 'react-loading';
import dayjs from 'dayjs';
import * as d3 from 'd3';

import KPICard from '../components/Dashboard/KPIMapCard.js';

import LineChart from '../components/D3/LineChart.js'

import optc from '../optc.json'

import {
  getLiveDataHook,
  getTracesRoutes,
  getTracesStops,
  getUserAgency,
  getPlanTrips,
  getLatest,
  getLatestVehRoutes

} from '../API.js';

import { useTranslation } from "react-i18next";

function Liveroutes() {

  const [t] = useTranslation('common');

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);

  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [stopGroup, setStopGroup] = useState(0);
  const [chunkSize, setChunkSize] = useState(50);
  const [loading, setLoading] = useState(0);

  const [traceRoutes, setTraceRoutes] = useState('');
  const [traceStops, setTraceStops] = useState('');

  const [vehOPTC, setVehOPTC] = useState({});
  const [plannedOPTC, setPlannedOPTC] = useState('');

  const [onlineStops, setOnlineStops] = useState([]);
  const [onlineStopsGroups, setOnlineStopsGroups] = useState([]);
  const [activeVehicles, setActiveVehicles] = useState('');
  const [activeRoutes, setActiveRoutes] = useState('');
  const [avgSpeed, setAvgSpeed] = useState('');
  const [avgOccupancy, setAvgOccupancy] = useState('');
  const [updateTime, setUpdateTime] = useState('');
  const [otp, setOtp] = useState('');

  const [firstLoad, setFirstLoad] = useState(0);


  //GET AGENCY SPECIFIC INFO (AGENCY, ROUTES, STOPS, VEHICLE POSITIONS)
  useEffect(() => {
    let cancelled = false;

    getUserAgency()
      .then(agencyResponse => {
        const selected = Array.isArray(agencyResponse) ? agencyResponse : [agencyResponse];
        if (cancelled || !selected[0]) return null;
        setUserAgency(selected);
        setAgency(selected[0]);

        return Promise.all([
          getTracesRoutes(selected),
          getTracesStops(selected),
          getLatestVehRoutes(selected[0]),
          getLatest(selected)
        ]).then(([traces, stops, vehInfo, planInfo]) => ({
          selected,
          traces,
          stops,
          vehInfo,
          planInfo
        }));
      })
      .then((payload) => {
        if (cancelled || !payload) return;

        const { selected, traces, stops, vehInfo, planInfo } = payload;
        if (!traces || !traces[0] || !vehInfo || !vehInfo[0]) return;

        setTraceRoutes(traces[0].jsonb_build_object);
        setTraceStops(stops);

        let newRouteData = vehInfo[0].jsonb_build_object.features;
        newRouteData.sort((a, b) => parseInt(a.properties.route_id) - parseInt(b.properties.route_id));

        setVehOPTC({
          optc: selected[0],
          data: { type: 'FeatureCollection', features: newRouteData }
        });
        setPlannedOPTC(planInfo);
        setRefreshKey(oldKey => oldKey + 1);
      })
      .catch(error => {
        // Handle errors here
      });

    return () => {
      cancelled = true;
    };
  }, [refreshKey2]);


  //CONNECT TO SOCKET AND SET PLANNED VEHICLE NUMBER AND REAL VEHICLE POSITIONS
  useEffect(() => {

    let cleanupGetData;
    let cancelled = false;

    getUserAgency()
      .then(response => {
        if (cancelled) return;

        const selected = Array.isArray(response) ? response[0] : response;
        setAgency(selected);

        cleanupGetData = getLiveDataHook((err, positions) => {
          if (!positions) return;

          const plannedVeh = Array.isArray(positions.newData) ? positions.newData.find((e) => e.operateur == selected) : null;
          const vehData = Array.isArray(positions.newRouteData) ? positions.newRouteData.find((e) => e.optc === selected) : null;
          if (!plannedVeh || !vehData || !vehData.data || !vehData.data.features) return;

          vehData.data.features.sort((a, b) => parseInt(a.properties.route_id) - parseInt(b.properties.route_id));

          setVehOPTC(vehData);
          setPlannedOPTC(plannedVeh.planned);
          setRefreshKey(oldKey => oldKey + 1);
          setFirstLoad(1);
        }, selected);
      });

    return () => {
      cancelled = true;
      if (cleanupGetData) {
        cleanupGetData(); // Call the cleanup function to disconnect the socket
      }
    };

  }, [refreshKey2]);


  //FILTER VEHICLES TO KEEP ONLY THE ONES FOR WHICH A ROUTE CAN BE ASSIGNED
  //SET STOP DATA FOR ROUTES THAT ARE ONLINE
  useEffect(() => {

    if (vehOPTC.optc && vehOPTC.data) {

      const features = Array.isArray(vehOPTC.data)
        ? vehOPTC.data
        : (vehOPTC.data.features || []);
      let vehClean = features.filter((e) => { return e.properties.route_id !== '' });
      vehClean.sort((a, b) => a.properties.route_id - b.properties.route_id);

      const stopGroups = [];
      for (let i = 0; i < vehClean.length; i += chunkSize) {
        const chunk = vehClean.slice(i, i + chunkSize);
        stopGroups.push({
          groupNo: i,
          data: chunk
        })
      }

      setOnlineStopsGroups(stopGroups);
    }

    setRefreshKey(oldKey => oldKey + 1);

  }, [vehOPTC, stopGroup])



  //EVAL POSITION OF VEHICLES ALONG ROUTES
  useEffect(() => {

    if (vehOPTC.optc && onlineStopsGroups.length > 0 && traceStops !== '' && traceRoutes !== '') {

      let onlineTraces = [];
      let onlineRouteDir = [];

      //   // List of active traces-route-direction
      let loopRoutes = onlineStopsGroups[stopGroup].data.forEach((e) => {
        let test = traceRoutes.features.forEach((f) => {
          let filterTrips = f.properties.trips.find((g) => { return g == e.properties.trip_id });
          if (filterTrips !== undefined && e.properties.route_id !== "") {
            onlineTraces.push({
              route: f.properties.ligne,
              direction: f.properties.direction,
              shape: f.properties.shape_id
            });
            onlineRouteDir.push({
              route: f.properties.ligne,
              direction: f.properties.direction,
            })
            //add direction to vehicle position to match with trace
            e.properties.direction = f.properties.direction;
          }
        });
      });

      // Unique route-dirs
      let uniqueOnlineRouteDir = [... new Set(onlineRouteDir)];

      let longestTraceOnline = [];

      // Keep longest variant for each route-direction
      uniqueOnlineRouteDir.forEach((e) => {
        // Online route-direction based on trace
        let filteredTraces = traceRoutes.features.filter((f) => {
          return f.properties.ligne == e.route && f.properties.direction == e.direction
        });
        filteredTraces.sort((a, b) => b.properties.distance - a.properties.distance);
        longestTraceOnline.push(filteredTraces[0]);
      })


      // Keep online route planned stops grouped by route
      let onlineStops = [];
      let stopLoop = traceStops.forEach((e) => {

        let res = longestTraceOnline.filter((f) => {
          return f.properties.shape_id == e.shape_id
        });

        if (res.length > 0) {
          onlineStops.push(e);
        }
      })

      // Get graph data together (stops + positions for each shape)

      onlineStops.forEach((e, i) => {

        let activeVehicles = [];

        //get stops info
        // x,y - position for d3 chart

        let stopsArray = e.jsonb_build_object.features.map((f) => { return f.properties });
        let stopCoords = [];
        stopsArray.forEach((f) => {
          stopCoords.push(
            {
              x: f.shape_dist_traveled,
              y: 0,
              name: f.name
            })
        })

        // get all active vehicles on route/direction
        let res = onlineStopsGroups[stopGroup].data.filter((f) => {
          return f.properties.route_id == longestTraceOnline.find((f) => { return e.shape_id == f.properties.shape_id }).properties.ligne
            && f.properties.direction == longestTraceOnline.find((f) => { return e.shape_id == f.properties.shape_id }).properties.direction;
        });

        // x,y - position for d3 chart
        res.forEach((f) => {
          activeVehicles.push({
            x: f.properties.distonline * f.properties.length,
            y: 0,
            pct_complete: f.properties.distonline,
            occupancy_status: f.properties.occupancy_status ? f.properties.occupancy_status : t('map.na'),
            route_id: f.properties.route_id,
            vehicle_id: f.properties.vehicle_id,
            trip_id: f.properties.trip_id,
            delay: f.properties.delay,
            agency: agency,
            speed: f.properties.speed ? f.properties.speed : t('map.na')
          });
        })

        e.trips = activeVehicles;
        e.plannedStops = stopCoords;
        //add route and direction
        e.route = longestTraceOnline.find((f) => { return e.shape_id == f.properties.shape_id }).properties.ligne;
        e.direction = longestTraceOnline.find((f) => { return e.shape_id == f.properties.shape_id }).properties.direction;
      })


      //KPIs
      //vehicles
      let unique_vehicles = [...new Set(vehOPTC.data.features.map(i => i.properties.vehicle_id))];
      //routes
      let unique_routes = [...new Set(vehOPTC.data.features.map(i => i.properties.route_id))];
      //speed
      let avgSpeed = vehOPTC.data.features.reduce(
        (accumulator, currentValue) => accumulator + parseFloat(currentValue.properties.speed),
        0
      ) / vehOPTC.data.features.length;
      //occupancy
      let avgOccupancy = vehOPTC.data.features.reduce(
        (accumulator, currentValue) => accumulator + parseInt(currentValue.properties.occupancy_status),
        0
      ) / vehOPTC.data.features.length;
      //update
      let time = dayjs(vehOPTC.data.features[0].properties.timestamp).format('HH:mm:ss');
      //otp
      //OTP based on delay at stops
      let onTime = 0;
      let early = 0;
      let late = 0;
      let total = vehOPTC.data.features.length;
      vehOPTC.data.features.forEach((e) => {
        if (e.properties.delay < -60) {
          early += 1;
        } else if (e.properties.delay > 180) {
          late += 1;
        } else (
          onTime += 1
        )
      })

      onlineStops.sort((a, b) => ((parseInt(a.route) + parseInt(a.direction)) - (parseInt(b.route) + parseInt(b.direction))));

      setOnlineStops(onlineStops);
      setActiveVehicles(unique_vehicles.length);
      setActiveRoutes(unique_routes.length);
      setAvgSpeed(avgSpeed.toFixed(1));
      setAvgOccupancy(avgOccupancy.toFixed(1));
      setUpdateTime(time);
      setLoading(0);
      setRefreshKey1(oldKey => oldKey + 1);
      setOtp(onTime / total);
    }


  }, [vehOPTC, stopGroup, refreshKey])


  const handleGroupChange = (e) => {

    d3.select("g").remove();
    setLoading(1);
    setStopGroup(parseInt(e.target.value));

  }

  const handleAgencySelect = (e) => {
    d3.select("g").remove();
    setAgency(e.target.value);
    setOnlineStops([]);
    setStopGroup(0);
    setRefreshKey2(oldKey => oldKey + 1);
  }

  //get otp limits
  const selectedAgency = agency || (Array.isArray(userAgency) ? userAgency[0] : userAgency);
  const selectedOptc = selectedAgency ? optc.optc.find((e) => e.operateur == selectedAgency) : null;
  const onTimeLimits = selectedOptc && selectedOptc.ontimelimits ? selectedOptc.ontimelimits : [-1, 3];
  const lowerLimit = (onTimeLimits[0] * 60) - 29;
  const higherLimit = (onTimeLimits[1] * 60) + 29;

  return (
    vehOPTC && onlineStops && userAgency &&
      onlineStopsGroups && onlineStops.length > 1 ?

      <React.Fragment>

        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm">
            <h1 id="page-title" className="display-5">{t('liveroutes.title')}</h1>
            {userAgency.length > 1 ? <div className="row justify-content-center mb-2">
              <h3 id="page-subtitle" className="display-5"><b>{(agency || (Array.isArray(userAgency) ? userAgency[0] : userAgency) || '').toString().toUpperCase()}</b> </h3>
            </div> : ''}
          </div>
        </div>


        <div className="container pt-1" style={{ backgroundColor: "#f8f9fa" }}>

          {/* <div className="row no-gutters align-items-center justify-content-center"> */}
          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 kpi-section-spaced">
            <KPICard
              kpi={updateTime ? updateTime : t('map.loading')}
              desc={t("liveroutes.updated")}
            />
            <KPICard
              kpi={activeVehicles ? activeVehicles + " / " + plannedOPTC : t('map.loading')}
              desc={t("liveroutes.active") + " / " + t("liveroutes.planned")}
            />
            <KPICard
              kpi={otp ? parseFloat(otp * 100).toFixed(0) + "%" : t('map.loading')}
              desc={t("map.ontime")}
            />
            <KPICard
              kpi={activeRoutes ? activeRoutes : t('map.loading')}
              desc={t("liveroutes.routes")}
            />
            <KPICard
              kpi={avgSpeed ? avgSpeed + ' km/h' : t('map.loading')}
              desc={t("liveroutes.speed")}
            />
            <KPICard
              kpi={avgOccupancy ? avgOccupancy : t('map.loading')}
              desc={t("liveroutes.load")}
            />
          </div>

          {userAgency.length > 1 ? <div className="row justify-content-center">
            <div className="col-lg-3">
              <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                <option defaultValue>Opérateur</option>
                {userAgency.map((e) => (
                  <option value={e} key={e}
                  >{e}</option>
                ))}
              </select>
            </div>
          </div> : ''}


          {onlineStopsGroups.length > 1 ? <div className="row justify-content-center">
            <div className="col-lg-3 col-sm-12 text-center">
              <select onChange={(e) => handleGroupChange(e)} className="form-select form-select-lg mb-3 mt-3">
                {onlineStopsGroups.map((e, i) => (
                  <option value={i} key={i}
                  >{t("liveroutes.route")} {e.data[0].properties.route_id + '-' + e.data[(e.data.length) - 1].properties.route_id}</option>
                ))}
              </select>
            </div>
          </div> : ''}


          <div className="row">
            {loading == 0 ?
              onlineStops.map((e) => (
                <div className="col-lg-12 pb-1 pt-1" key={e.shape_id + e.route_id}>
                  <div className="text-center">{t("liveroutes.route")} {e.route} | Direction {e.direction}</div>
                  <div className="rounded">
                    <LineChart
                      data1={e}
                      color={selectedOptc ? selectedOptc.color : '#4d0077'}
                      keyid={e.shape_id}
                      refreshKey={refreshKey1}
                      higherLimit={higherLimit}
                      lowerLimit={lowerLimit}
                    />
                  </div>
                </div>)) :
              <div className="mapspinner">
                <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
              </div>}
          </div>

        </div>
      </React.Fragment>

      :
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
  )
}

export default Liveroutes;